import { ICompetenceGroupsService } from "../../core/competencegroups.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { CompetenceGroups } from "./competencegroups.component";
import { EditCompetenceGroup } from "./competencegroup.edit.component";
import { CompetenceGroup } from "./competencegroup.component";

/**
 * This state displays all Competence Groups
 */
export const competenceGroupsState: Ng2StateDeclaration = {
    name: "app.settings.competencegroups",
    url: "/competencegroups",
    views: {
        "main-view@app": {
            component: CompetenceGroups
        }
    },
    resolve: {
        competencegroups: ["competenceGroupsService", (competenceGroupsService: ICompetenceGroupsService) => {
            return competenceGroupsService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Competence Group
 */
export const newCompetenceGroupState: Ng2StateDeclaration = {
    name: "app.settings.competencegroups.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditCompetenceGroup
        }
    },
    resolve: {
        competencegroup: function () {
            return <Nema.Crew.Model.CompetenceGroup>{ Id: -1, Name: "", Active: true, SortTag: "", CompetenceTypeCVMappingCompetenceGroups: null, CompetenceTypes: null, Description: "" };
        },
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Competence Group
 */
export const editCompetenceGroupState: Ng2StateDeclaration = {
    name: "app.settings.competencegroups.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditCompetenceGroup
        }
    },
    resolve: {
        competencegroup: ["competenceGroupsService", "$stateParams", function (competenceGroupsService: ICompetenceGroupsService, $stateParams) {
            return competenceGroupsService.get($stateParams.id);
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Competence Group Details state
 */
export const competenceGroupState: Ng2StateDeclaration = {
    name: "app.settings.competencegroups.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: CompetenceGroup
        }
    },
    resolve: {
        competencegroup: ["competenceGroupsService", "$stateParams", function (competenceGroupsService: ICompetenceGroupsService, $stateParams) {
            return competenceGroupsService.get($stateParams.id);
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencegroups/competencegroups.states.ts